<template>
  <div class="schoolset">
    <div class="content">
      <div class="schoolinfo-wrapper" v-if="schoolNow">
        <section class="top">{{$t('m.school_s_basic_information')}}</section>
        <section class="bottom">
          <div class="schoolinfo-top-wrapper">
            <div class="img-wrapper">
              <img :src="computeUrl(schoolNow.faceimg)" alt="faceimg" width="100" height="100">
            </div>
            <div class="text-wrapper">
              <h2 class="title">{{decodeURIComponent(schoolNow.roomname)}}</h2>
              <p class="type">{{decodeURIComponent(schoolNow.roomtypename)}}</p>
              <p class="identity">
                {{$t('m.school_s_system')}}
                <template v-if="schoolNow.roomidentity==1">个人</template>
                <template v-else>机构</template>
              </p>
              <div class="btn-wrapper">
                <button class="change"
                        v-if="schoolNow.iscreator||schoolNow.ismanager"
                        @click="showModifySchool(schoolNow)">{{$t('m.school_s_modify')}}
                </button>
              </div>
            </div>
          </div>
          <div class="introduce" v-if="!isEmpty(computeUpIntroduceList(schoolNow.introduce))">
            <p class="intro-title">{{$t('m.school_s_introduce')}}</p>
            <template v-for="(item,index) in computeUpIntroduceList(schoolNow.introduce)">
              <pre class="text" v-if="item.isImage==false&&item.text!==''">{{item.text}}</pre>
              <div class="image" v-if="item.isImage==true&&item.width!==0">
                <img :src="imgprefix+item.image" alt="img" width="100%">
              </div>
            </template>
          </div>
        </section>
      </div>
    </div>
    <div class="classpop-mask" v-if="modifyShow">
      <div class="classpop">
        <h2 class="title">{{$t('m.school_s_modify_data')}}</h2>
        <div class="cover-row">
          <span class="left">{{$t('m.school_s_avatar')}}</span>
          <span class="right">
            <span class="img-wrapper">
              <img class="img" :src="imgurl" alt="cover" width="100" height="100">
            </span>
            <div class="upload-button-wrapper">
              <vue-core-image-upload
                class="upload-button"
                crop="local"
                text="选择本地图片"
                :cropBtn="{ok:'确定','cancel':'取消'}"
                cropRatio="1:1"
                @imageuploaded="imageuploaded"
                :max-file-size="5242880"
                :url="imgUpUrl">
                </vue-core-image-upload>
            </div>
          </span>
        </div>
        <p class="row">
          <span class="left">{{$t('m.school_s_name')}}</span>
          <input type="text" class="input-name" v-model="schoolName" maxlength="10">
        </p>
        <p class="row">
          <span class="left">{{$t('m.school_s_system')}}</span>
          <select name="sex" id="sex" class="type-select" v-model="identity">
            <option value="1">个人</option>
            <option value="2">机构</option>
          </select>
        </p>
        <p class="row">
          <span class="left">{{$t('m.school_s_type')}}</span>
          <el-cascader
            :options="firstType"
            v-model="selectedOptions"
            size="small">
          </el-cascader>
        </p>
        <div class="split"></div>
        <div class="add-introduce">
          <span class="left">{{$t('m.school_s_introduce2')}}</span>
          <div class="right">
            <template v-for="(item,index) in introduceList">
              <div class="text-wrapper" v-if="item.isImage===false">
                <textarea class="text" v-model='item.text' name="text" cols="30" rows="10"></textarea>
                <img class="img" @click="del(index)" src="./delete.png" alt="delete-button" width="24" height="24">
              </div>
              <div class="img-wrapper" v-if="item.isImage===true">
                <div class="img-left">
                  <img class='showimg' :src="introduceImgUrl(item)" alt="img" width="100" height="100"><input
                  class="input" type="file" accept="image/*" @change="upImg(index,$event)"/>
                </div>
                <img class="img" @click="del(index)" src="./delete.png" alt="delete-button" width="24" height="24">
              </div>

            </template>
            <button class="add" @click="addText">{{$t('m.school_s_addtext')}}</button>
            <button class="add" @click="addImage">{{$t('m.school_s_addimg')}}</button>
          </div>
        </div>
        <div class="operate-btn-wrapper">
          <button class="btn cancel" @click="modifyShow=false">{{$t('m.cancel')}}</button>
          <button class="btn confirm" @click="modifySchool">{{$t('m.confirm')}}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
  import {saveLocal, loadLocal} from 'common/js/store.js';
  import VueCoreImageUpload from 'vue-core-image-upload';
  export default{
    data(){
      return {
        id: (() => loadLocal('id', false))(),
        schoolNow: (() => loadLocal('schoolNow', false))(),
        imgprefix: (() => loadLocal('imgprefix', false))(),
        //----------以下内容和修改老师资料有关-------------//
        modifyShow: false,
        imgUpUrl: '',              //该url是组件‘vue-core-image-upload’上传的url地址（带sessionid）
        imgurl: require('./cover.png'),
        upurl: '',
        schoolName: '',             //网校名称
        selectedOptions: [],      //表示选中的选项
        firstType: [],
        identity: '',
        introduceList: [],           //老师的图文介绍
        index: 0,        //根据上传图片确定index，从而对相应的list[this.index]赋值
      }
    },
    methods: {
      isEmpty(obj){
        for (let i in obj) {
          return !1;
        }
        return !0;
      },
      computeUrl(url){
        if (url === '') {
          return require('./cover.png');
        } else {
          return this.imgprefix + url;
        }
      },
      computeUpIntroduceList(list){
        if (this.isEmpty(list)) {
          return '';
        } else {
          return JSON.parse(decodeURIComponent(list));
        }
      },
      //-----------------------以下内容和修改网校信息有关--------------//
      //打开修改网校资料界面
      showModifySchool(item){
        this.imgurl = require('./cover.png');
        this.upurl = '';
        this.modifyShow = true;
        this.schoolName = decodeURIComponent(item.roomname);
        this.identity = item.roomidentity;
        if (item.faceimg !== '') {
          this.imgurl = this.imgprefix + item.faceimg;
          this.upurl = item.faceimg;
        }
        if (item.introduce == '') {
          this.introduceList = [];
        } else {
          this.introduceList = JSON.parse(decodeURIComponent(item.introduce));
        }
        if (item.roomtype !== '') {
          this.selectedOptions[0] = item.roomtype + '';
        }
      },
      del: function (index) {
        this.introduceList.splice(index, 1);
        this.$forceUpdate()  // 迫使 Vue 实例重新渲染。
      },
      //增加文字、图片的相关方法
      addText(){
        let oText = {
          "isImage": false,
          "text": '',
        };
        this.introduceList.push(oText);
        this.$forceUpdate();
      },
      addImage(){
        let oText = {
          "isImage": true,
          "image": './addImage.png',
          "width": 0,
          "height": 0,
        };
        this.introduceList.push(oText);
        this.$forceUpdate();
      },
      introduceImgUrl(item){
        if (item.image == './addImage.png') {
          return require('./addImage.png');
        } else {
          return this.imgprefix + item.image;
        }
      },
      upImg: function (index, e) {
        this.index = index;
        let input = e.target;
        // 通过DOM取文件数据
        let file = input.files[0];
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function (e) {
          let image = input.previousSibling;
          image.src = e.target.result;
        };
        let xhr = new XMLHttpRequest();
        //initiate request
        let url = '/indexapp.php?c=Upload&a=UploadFileNew&id=' + this.id;
        xhr.open('post', url, true);
        //set headers
        xhr.setRequestHeader('X-File-Name', encodeURI(file.name));
        xhr.setRequestHeader('X-File-Size', file.size);
        xhr.setRequestHeader('X-File-Type', file.type);
        xhr.addEventListener('load', this.uploadComplete, false);
        //send the file
        xhr.send(file);
      },
      uploadComplete: function (evt) {

        let response = evt.target.responseText;
        let jsonobj = JSON.parse(response);
        this.$set(this.introduceList[this.index], 'image', jsonobj.image);
        this.$set(this.introduceList[this.index], 'width', jsonobj.imagewidth);
        this.$set(this.introduceList[this.index], 'height', jsonobj.imageheight);
        this.$forceUpdate();

      },
      //VueCoreImageUpload上传后调用的方法
      imageuploaded(response) {
        if (response.code === 111) {
          this.$router.push({path:'/log',query:{url:this.$getUrl.getUrl()}});
        } else if (response.code === 200) {
          this.imgurl = response.imgprefix + response.image;
          this.upurl = response.image;
        }
      },
      //根据当前introduceList的值，返回相应的符合上传需求的数据
      calculateIntroduceList(list){
        if (this.isEmpty(list)) {
          return '';
        } else {
          let result = [];
          for (let i = 0; i < list.length; i++) {
            if (list[i].isImage === true) {
              if (list[i].width === 0) {
                continue;
              }
            } else {
              if (list[i].text === '') {
                continue;
              }
            }
            result.push(list[i]);
          }
          result = JSON.stringify(result);
          result = encodeURIComponent(result);
          return result;
        }
      },
      modifySchool(){
        if (this.upurl === '') {
          this.$message({
            message: '请上传网校头像',
            type: 'warning'
          });
          return;
        }
        if (this.schoolName === '') {
          this.$message({
            message: '请输入网校名称',
            type: 'warning'
          });
          return;
        }
        if(this.identity=== ''){
          this.$message({
            message: '请选择网校体系',
            type: 'warning'
          });
          return;
        }
        if(this.isEmpty(this.selectedOptions)){
          this.$message({
            message: '请选择网校类型',
            type: 'warning'
          });
          return;
        }
        let url = '/indexapp.php?c=Room&a=UpdateRoomInfo';
        let params = new URLSearchParams();
        params.append('id', this.id);
        params.append('rid', this.schoolNow.rid);
        params.append('faceimg', this.upurl);
        params.append('roomname', this.schoolName);
        params.append('roomidentity', this.identity);
        params.append('roomtype', this.selectedOptions[0]);
        let introduce = this.calculateIntroduceList(this.introduceList);
        params.append('introduce', introduce);
        this.$http({
          url: url,
          method: 'post',
          data: params,
        }).then((response) => {
          response = response.data;
          if (response.code === 111) {
            this.$router.push({path:'/log',query:{url:this.$getUrl.getUrl()}});
          }
          if (response.code === 200) {
            this.modifyShow = false;
            this.$message({
              message: '更新网校资料成功',
              type: 'success'
            });
            this.RoomInfo();
            this.$forceUpdate();
          }else{
            this.$message({
              message: response.msg,
              type: 'warning'
            });
          }
        }).catch((err) => {
          this.$alert('未获取到数据，请重新加载页面', '提示', {
            confirmButtonText: '刷新',
            callback: action => {
              window.location.reload();
            }
          });
        })
      },
      RoomInfo(){
        this.$http({
          url: '/indexapp.php',
          method: 'GET',
          params: {
            c: 'Room',
            a: 'RoomInfo',
            id: this.id,
            rid: this.schoolNow.rid,
          }
        }).then((response) => {
          response = response.data;
          if (response.code === 111) {
            this.$router.push({path:'/log',query:{url:this.$getUrl.getUrl()}});
          }
          if (response.code === 200) {
            this.schoolNow = response.list[0];
            saveLocal('schoolNow', this.schoolNow);
          }
        }).catch((err) => {
          this.$alert('未获取到数据，请重新加载页面', '提示', {
            confirmButtonText: '刷新',
            callback: action => {
              window.location.reload();
            }
          });
        })
      },
      //将从服务器获取到的数据增加value字段和label字段
      nameOption(obj){
        for (let i = 0; i < obj.length; i++) {
          obj[i].value = obj[i].id;
          obj[i].label = obj[i].name;
        }
      },
      loadType(){
        //获取第一大分类
        this.$http({
          url: '/indexapp.php',
          method: 'GET',
          params: {
            c: 'Lesson',
            a: 'QueryLessonType',
            parentid: 0
          }
        }).then((response) => {
          response = response.data;
          if (response.code === 111) {
            this.$router.push({path:'/log',query:{url:this.$getUrl.getUrl()}});
          } else if (response.code === 200) {
            this.firstType = response.list;
            this.nameOption(this.firstType);
          }
        }).catch((err) => {
          this.$alert('未获取到数据，请重新加载页面', '提示', {
            confirmButtonText: '刷新',
            callback: action => {
              window.location.reload();
            }
          });
        });
      },
    },
    created(){
      this.imgUpUrl = `${this.GLOBAL.uploadUrl}indexapp.php?c=Upload&a=UploadFileVue&id=` + this.id;
      //获取网校类别
      this.loadType();
    },
    components: {
      VueCoreImageUpload,
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
  .schoolset
    width: 100%
    height: 100%
    background: #f2f2f2
    font-size: 0
    overflow auto
    .content
      margin: 111px 20px 20px 180px
      width: 1166px
      .schoolinfo-wrapper
        background #fff
        .top
          height: 50px
          line-height: 50px
          border-bottom: 1px solid #e4e4e4
          font-size: 15px
          color: #555555
          font-weight: bold
          text-indent: 38px
          background url(./homepage.png) no-repeat left 10px center / 18px 18px
        .bottom
          padding: 40px
          .schoolinfo-top-wrapper
            padding-bottom: 30px
            border-bottom: 1px dashed #e4e4e4
            overflow hidden
            .img-wrapper
              float: left
              width: 100px
              height: 100px
            .text-wrapper
              float: left
              margin-left: 25px
              width: calc(100% - 125px)
              position relative
              .title
                font-size: 20px
                color: #000000
                font-weight: bold
                padding-top: 6px
                height: 28px
                line-height: 28px
              .type, .identity
                font-size: 14px
                color: #888888
                height: 18px
                line-height: 18px
              .type
                margin: 20px 0 10px
              .btn-wrapper
                position absolute
                right: 0
                top: 0
                .change
                  margin-bottom: 5px
                  padding: 0 10px
                  height: 28px
                  line-height: 28px
                  background #3399ff
                  color: #ffffff
                  font-size: 14px
                  border-radius 4px

          .introduce
            width: 100%
            .intro-title
              padding: 20px 0 30px
              height: 20px
              line-height: 20px
              font-size: 14px
              color: #666
            img
              margin-bottom: 5px
            .text
              /*<pre>标签让<textarea>标签的内容原样输出http://www.cnblogs.com/mizzle/p/3874802.html*/
              margin-bottom: 5px
              padding: 0
              font-size: 14px
              text-align: left
              line-height: 18px
              color: #000
              width: 100%
              white-space: pre-wrap
              word-wrap: break-word
              word-break: break-all
    .classpop-mask
      position: fixed
      top: 0
      bottom: 0
      left: 0
      right: 0
      display: flex
      background: rgba(0, 0, 0, 0.3)
      z-index: 1000
      overflow: auto
      .classpop
        margin: auto
        width: 1005px
        padding-left: 80px
        border-radius: 4px
        background: #ffffff
        font-size: 0
        box-sizing border-box
        .title
          padding: 30px 0 50px
          line-height: 38px
          font-size: 28px
          color: #333333
          font-weight: bold
          .close
            float: right
            margin-right: 75px
            cursor pointer
        .cover-row
          margin-bottom: 12px
          height: 140px
          .left
            display: inline-block
            margin-right: 10px
            width: 75px
            height: 100%
            line-height: 100px
            font-size: 15px
            color: #888
            vertical-align: top
          .right
            display: inline-block
            .img
              vertical-align: top
            .upload-button-wrapper
              height: 30px
              margin-top: 10px
              padding-left: 10px
              .upload-button
                display: inline-block
                margin-right: 10px
                height: 30px
                line-height: 30px
                width: 90px
                text-align: center
                background: #f2f2f2
                color: #666
                font-size: 13px
                border: 1px solid #d7d7d7
                border-radius: 4px
                box-sizing border-box
                vertical-align: top
                cursor: pointer
              .hint
                display: inline-block
                width: 235px
                height: 28px
                line-height: 28px
                text-align: center
                font-size: 12px
                color: #999999
                border-radius: 4px
                border: 1px solid #ffb76e
                background: #fff9e7

        .row
          margin-bottom: 10px
          height: 35px
          .left
            display: inline-block
            margin-right: 10px
            line-height: 35px
            width: 75px
            font-size: 15px
            color: #888
          .type-select
            width: 105px
            font-size: 14px
            color: #000
            border: 1px solid #e4e4e4
            height: 35px
            -webkit-appearance: none
            -moz-appearance: none
            appearance: none
            background: #fff url('down.png') no-repeat right 9px center
            background-size: 12px 12px
            padding: 0 30px 0 6px
            border-radius: 4px
            box-sizing: border-box
          .input-name
            width: 280px
            height: 35px
            font-size: 15px
            color: #000
            padding-left: 6px
            border: 1px solid #d7d7d7
            border-radius: 4px
            box-sizing: border-box
            &::-webkit-input-placeholder
              color: #ccc
          .text
            display: inline-block
            height: 35px
            line-height: 35px
            font-size: 15px
            color: #888
        .split
          margin-bottom: 20px
          height: 10px
          width: 845px
          border-bottom: 2px dashed #d7d7d7
        .add-introduce
          width: 880px
          overflow hidden
          .left
            float: left
            margin-right: 10px
            line-height: 35px
            width: 75px
            font-size: 15px
            color: #888
          .right
            float: left
            width: 795px
            .text-wrapper
              display: flex
              align-items center
              margin-bottom: 10px
              .text
                padding: 10px
                width: 760px
                height: 100px
                font-size: 15px
                color: #000
                box-sizing border-box
                border-radius 4px
                border: 1px solid #d7d7d7
                line-height: 20px
                resize: none
              .img
                margin-left: 10px
                cursor pointer

            .img-wrapper
              display: flex
              align-items center
              justify-content space-between
              margin-bottom: 10px
              .img-left
                width: 760px
                height: 100px
                position relative
                .input
                  position: absolute
                  left: 0
                  top: 0
                  height: 100px
                  width: 100px
                  padding: 0
                  margin: 0
                  opacity: 0

            .add
              margin-right: 10px
              height: 34px
              line-height: 34px
              width: 80px
              font-size: 14px
              color: #555555
              border: 1px solid #d7d7d7
              box-sizing border-box
              border-radius 4px

        .operate-btn-wrapper
          margin: 70px 0 30px 50px
          .btn
            margin-right: 65px
            width: 80px
            height: 34px
            line-height: 34px
            font-size: 16px
            color: #ffffff
            border-radius 4px
          .cancel
            background #ccc
          .confirm
            background #3399ff

</style>



// WEBPACK FOOTER //
// src/page/school/schoolset/SchoolSet.vue